






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponsavelWebhook} from '@/model/resource/ResponsavelWebhook'
import {InputResponsavelWebhookSchema} from '@/schema/resource/ResponsavelWebhook/InputResponsavelWebhookSchema'

@Component
export default class PersistResponsavelWebhookView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelWebhookSchema()
  responsavelWebhook = new ResponsavelWebhook()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
    this.schema.collectionTypeWebhook.listTypeWebhook()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavelWebhook.getResponsavelWebhook(id)
    }

    $.await.done('getResponsavelWebhook')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responsavelWebhook.persistResponsavelWebhook()
    await Helper.successAndPush(
      'system.success.persist',
      '/responsavel-webhook/list'
    )
  }
}
